import { render, staticRenderFns } from "./Keypads.vue?vue&type=template&id=45344f0d&"
import script from "./Keypads.vue?vue&type=script&lang=js&"
export * from "./Keypads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports